module.exports = __webpack_public_path__ + "static/media/portfolio2014Portfolio.69b124cf.jpg";